module.exports = __webpack_public_path__ + "img/bcc069.15446d96.jpeg";